import React from "react";
// libs
import axios from "src/libs/axios";
// const
import { ENDPOINTS } from "src/constants/endpoints";
// types
import { IReview, IReviewStatistic } from "src/types";

interface IUseReviewsResponse {
  loadReviews: (params?: string) => Promise<IReview[]>;
  loadReviewsCount: (params?: string) => Promise<number>;
  leaveReview: (body: ILeaveReviewBody) => Promise<IReview>;
  loadReviewsStatistic: (params?: string) => Promise<IReviewStatistic>;
}

interface ILeaveReviewBody {
  description: string;
  rating: number;
  other_reasons: string;
  reasons_array: string[];
  reviewer_name: string;
  is_name_hidden: boolean;
  pets_name: string;
  email: string;
  clinic: number; // ID
}

type TUseReviews = () => IUseReviewsResponse;

export const useReviews: TUseReviews = () => {
  const loadReviews: IUseReviewsResponse["loadReviews"] = async (params = "") => {
    const { data } = await axios.get(ENDPOINTS.GET.reviews + "?" + params);
    return data;
  };

  const loadReviewsCount: IUseReviewsResponse["loadReviewsCount"] = async (params = "") => {
    const { data } = await axios.get(ENDPOINTS.GET.reviewsCount + "?" + params);
    return data;
  };

  const leaveReview: IUseReviewsResponse["leaveReview"] = async (body) => {
    const { data } = await axios.post(ENDPOINTS.POST.leaveReview, body);
    return data;
  };

  const loadReviewsStatistic: IUseReviewsResponse["loadReviewsStatistic"] = async (params) => {
    const { data } = await axios.get(ENDPOINTS.GET.reviewsStatistic + "?" + params);
    return data;
  };

  return {
    loadReviews,
    loadReviewsCount,
    leaveReview,
    loadReviewsStatistic,
  };
};
